<style type="text/css">
  .v-card.section-toolbar-top {
    position: absolute;
    right: 30px;
    z-index: 1;
    display: flex;
    gap: 20px;
    padding: 7px 15px;
    padding: 5px;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    background-color: #ededed;
    background-color: #fff;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
</style>


<template>
  <div
    v-if="shouldShowToggle"
    style="position:relative;"
    :style="moduleOrSection.id !== 'module_cover' && moduleOrSection.id !== 'section_timeline' && moduleOrSection.id !== 'section_environment' ? 'margin-top: 50px' : ''"
  >
    <v-card
      class="section-toolbar-top"
      flat
      :style="moduleOrSection.id === 'section_timeline' || moduleOrSection.id === 'section_environment' ? 'top: 1px' : 'top: -30px'"
      style="color: red"
    >
      <v-btn
        x-small
        color="primary"
        @click="editModuleOrSection(moduleOrSection)"
        data-testid="template-section-toolbar--btn-toggle"
      >
        <span v-if="shouldShowGoBackLabel">{{ translate('ui_dialog_back_to_preview') }}</span>
        <span v-if="shouldShowEditLabel">
          <v-icon x-small style="margin-right: 5px;">mdi-cog</v-icon>{{ translate('ui_dialog_edit') }} {{ sectionName }}</span>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateSectionToolbarEditToggle',
  components: {},
  mixins: [Mixin],
  props: {
    moduleOrSection: {},
  },
  methods: {
    toggleCollapsedState(e, section) {
      e.stopPropagation();
      const { sections } = this.$store.state.activeTemplate.data;
      const sectionIndex = sections.findIndex((sect) => sect.id === section.id);
      sections[sectionIndex].isCollapsed = !section.isCollapsed;
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.sections',
        value: sections,
      });
    },
  },
  computed: {
    shouldShowEditLabel() {
      const alwaysShowForModules = ['module_cover', 'section_timeline'];
      const shouldAlwaysShow = alwaysShowForModules.includes(this.moduleOrSection.id);
      const shouldShowForThisModuleOrSection = this.moduleOrSection.templateSectionCfg && this.moduleOrSection.templateSectionCfg.id ? !this.getSectionById(this.moduleOrSection.templateSectionCfg.id).isEditingSettings : false;
      return shouldAlwaysShow || shouldShowForThisModuleOrSection;
    },
    shouldShowGoBackLabel() {
      return this.moduleOrSection.templateSectionCfg && this.moduleOrSection.templateSectionCfg.id ? this.getSectionById(this.moduleOrSection.templateSectionCfg.id).isEditingSettings : false;
    },
    shouldShowToggle() {
      const isTemplatePaidFor = !this.$store.state.activeTemplate.price;
      const isGeneratingResolved = typeof this.$store.state.activeTemplate.isGenerating === 'undefined' || this.$store.state.activeTemplate.isGenerating === 'done';
      return isTemplatePaidFor && this.$store.state.isEditingToolsVisible && isGeneratingResolved && (this.shouldShowEditLabel || this.shouldShowGoBackLabel);
    },
    sectionName() {
      const module = this.$store.state.activeTemplate.data.modules.find((m) => m.id === this.moduleOrSection.id);
      return this.translate(module ? module.id : this.moduleOrSection.title);
    },
  },
};
</script>
